import { createContext } from 'react'

export interface monolithConfig {
  clientAddress: string
  clientType: 'mock' | 'api'
  appEnv: 'development' | 'production'
}

export const getMonolithConfig = (): monolithConfig => {
  const clientAddress = process.env.NEXT_PUBLIC_CLIENT_ADDRESS_PTV
  const clientType = process.env.NEXT_PUBLIC_CLIENT_TYPE
  const appEnv = process.env.NEXT_PUBLIC_APP_ENV
  if (clientAddress === undefined) {
    throw new Error('Client address not defined. ENV var NEXT_PUBLIC_CLIENT_ADDRESS_PTV')
  }
  if (clientType !== 'mock' && clientType !== 'api') {
    throw new Error('clientType is not valid. ENV var NEXT_PUBLIC_CLIENT_TYPE')
  }
  if (appEnv !== 'development' && appEnv !== 'production') {
    throw new Error('appEnv is not valid. ENV var NEXT_PUBLIC_APP_ENV')
  }
  return { clientAddress, clientType, appEnv }
}
createContext<monolithConfig>({
  clientAddress: '',
  clientType: 'mock',
  appEnv: 'development',
})
